import { Fragment, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  Typography,
  Chip,
  CircularProgress,
  Button,
  Collapse,
  Paper,
  TextField,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  Divider,
} from "@material-ui/core";
import { FilterListOutlined, AddOutlined, Edit, WatchOutlined, Visibility } from "@material-ui/icons";
// import { shallowEqual, useSelector } from "react-redux";
// import { selectTheme } from "../../features/data/theme/themeSlice";
import { Pagination } from "@material-ui/lab";
import { useFetch } from "../../features/customHooks/useFetch";
import { useStyles } from "./valuationList.styles";
// import ValuationRow from "../../components/valuationRow/ValuationRow";
import ValuationFiltersForm from "../../components/valuationFiltersForm/ValuationFiltersForm";
import ValuationAppendedFilters from "../../components/valuationAppendedFilters/ValuationAppendedFilters";
import jMoment from "moment-jalaali";
import { shallowEqual, useSelector } from "react-redux";
import { selectUser } from "../../features/data/user/userSlice";

const ValuationList = (props) => {
  const classes = useStyles();
  // const { theme } = useSelector(selectTheme, shallowEqual);

  const { user } = useSelector(selectUser, shallowEqual);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const filtersRef = useRef(null);

  const handleToggleFilters = () => setFiltersOpen((prevState) => !prevState);

  const pageNumRef = useRef(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState("10");
  const [count, setCount] = useState(0);
  const [type, setType] = useState(user.role === "read_only" ? "all" : "user");
  const [filters, setFilters] = useState({});

  const [getFetchState, setGetFetchParams] = useFetch();

  const [goToPageDialogOpen, setGoToPageDialogOpen] = useState(false);
  const handleGoToPageDialogOpen = () => setGoToPageDialogOpen(true);
  const handleGoToPageDialogClose = () => setGoToPageDialogOpen(false);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const getValuation = () => {
    var data = {};
    Object.entries(filters).forEach(([key, value]) => {
      switch (key) {
        case "from_date":
        case "to_date":
          data[key] = Math.floor(new Date(value) / 1000);
          break;
        default:
          data[key] = value;
          break;
      }
    });

    data["page"] = page;
    data["per_page"] = parseInt(perPage);
    data["who"] = type;

    const params = {
      method: "get",
      url: "/valuation",
      data: { ...data },
      headers: { "Content-Type": "multipart/form-data" },
    };
    setGetFetchParams(params);
  };

  const onSubmitFiltersForm = (data, event) => {
    const filteredFilters = Object.fromEntries(Object.entries(data).filter(([_, v]) => v));
    if (Object.keys(filteredFilters).length > 0) setFilters(filteredFilters);
  };

  useEffect(() => {
    getValuation();
  }, [page, type, filters, perPage]); // eslint-disable-line

  useEffect(() => {
    if (!getFetchState.loading && !getFetchState.error && getFetchState.data)
      setCount(getFetchState?.data?.meta?.last_page);

    if (!getFetchState.loading && getFetchState.error) console.log("error");
  }, [getFetchState]);

  const nullHandler = (data) => data;

  return (
    <Grid container className={classes.container}>
      <Grid container justifyContent='flex-start' alignItems='center'>
        <Typography className={classes.titleTypo}>ارزیابی‌ها</Typography>
        {(user?.role === "user" || user.role === "admin") && (
          <Fragment>
            <Chip
              color={type === "user" ? "primary" : "secondary"}
              variant={type === "user" ? "default" : "outlined"}
              label='من'
              onClick={() => {
                setType("user");
                setPage(1);
              }}
              className={classes.chips}
            />

            <Chip
              color={type === "all" ? "primary" : "secondary"}
              variant={type === "all" ? "default" : "outlined"}
              label='همه'
              onClick={() => {
                setType("all");
                setPage(1);
              }}
              className={classes.chips}
            />
          </Fragment>
        )}
        <div className={classes.flexGrow} />

        <Button variant='contained' color='primary' endIcon={<FilterListOutlined />} onClick={handleToggleFilters}>
          فیلترها
        </Button>
        {user.role !== "read_only" && (
          <Link to='../valuations/new'>
            <Button variant='contained' color='primary' endIcon={<AddOutlined />} style={{ marginRight: 10 }}>
              ارزیابی جدید
            </Button>
          </Link>
        )}
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Collapse in={filtersOpen}>
            <Paper className={classes.filtersPaper}>
              <ValuationFiltersForm ref={filtersRef} onSubmitForm={onSubmitFiltersForm} />
              <Grid container alignItems='center' justifyContent='flex-end'>
                <Button color='default' onClick={handleToggleFilters} className={classes.button}>
                  بستن
                </Button>
                <Button color='default' onClick={() => filtersRef?.current?.reset()} className={classes.button}>
                  پاک کردن فرم
                </Button>
                <Button
                  color='primary'
                  variant='contained'
                  onClick={() => {
                    filtersRef?.current?.submit();
                    handleToggleFilters();
                  }}
                  className={classes.button}
                >
                  اعمال فیلتر
                </Button>
              </Grid>
            </Paper>
          </Collapse>
        </Grid>
      </Grid>

      <ValuationAppendedFilters filters={filters} setFilters={setFilters} />

      {/* <Grid container alignItems='center' justifyContent='center' spacing={3} style={{ marginTop: 5 }}>
        {getFetchState.loading ? (
          <CircularProgress />
        ) : getFetchState?.data?.data?.length > 0 ? (
          getFetchState?.data?.data?.map((valuation) => <ValuationRow data={{ valuation }} key={valuation?.id} />)
        ) : (
          <Chip label='ارزیابی برای نمایش وجود ندارد!' style={{ margin: 20 }} />
        )}
      </Grid> */}

      <Grid item style={{ flex: "1 1 auto" }}>
        <Paper
          style={{
            overflow: "hidden",
            marginTop: 20,
            position: "relative",
            height: "100%",
          }}
        >
          {getFetchState.loading && (
            <Grid
              container
              alignItems='center'
              justifyContent='center'
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 1000,
                // backdropFilter: "blur(5px)",
                backgroundColor: "#ffffff77",
                pointerEvents: "none",
              }}
            >
              <CircularProgress />
            </Grid>
          )}
          <Grid
            container
            style={{
              // overflow: orders.isFetching ? "hidden" : "auto",
              overflow: "auto",
              position: "relative",
              height: "100%",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "0px",
                height: "0px",
              }}
            >
              <Table aria-label='simple table' stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>عملیات</TableCell>
                    <TableCell>شناسه کل</TableCell>
                    {(user?.role === "user" || user.role === "admin" || user.role === "read_only") && (
                      <>
                        <TableCell>دفتر کارشناسی</TableCell>
                        <TableCell>نام ارزیاب</TableCell>
                      </>
                    )}
                    <TableCell>نام و نام خانوادگی مالک</TableCell>
                    <TableCell>شماره همراه مالک</TableCell>
                    <TableCell>تاریخ</TableCell>
                    <TableCell>آدرس</TableCell>
                    <TableCell>شناسه</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getFetchState?.data?.data?.map((valuation, index) => {
                    const date = new Date(valuation?.date);

                    const today = new Date();
                    const yesterday = new Date();
                    yesterday.setDate(today.getDate() - 1);

                    return (
                      <TableRow
                        key={valuation.id}
                        style={{
                          // "&:last-child td, &:last-child th": { border: 0 },
                          "td, th": { border: 0 },
                          td: {
                            backgroundColor: index % 2 === 0 ? "#7165e311" : "transparent",
                          },
                        }}
                      >
                        <TableCell>
                          <Grid container alignItems='center'>
                            <Link to={`../valuations/view/${valuation?.id}`} target={"_blank"}>
                              <Tooltip title='مشاهده'>
                                <IconButton size='small'>
                                  <Visibility />
                                </IconButton>
                              </Tooltip>
                            </Link>
                            {date.getTime() < today.getTime() && date.getTime() >= yesterday.getTime() && (
                              <>
                                <Divider variant='middle' orientation='vertical' flexItem />
                                <Chip size='small' label='جدید' />
                              </>
                            )}
                          </Grid>
                        </TableCell>
                        <TableCell>{nullHandler(valuation?.full_id)?.toString()?.toPersianDigits()}</TableCell>
                        {(user.role === "user" || user.role === "admin" || user.role === "read_only") && (
                          <>
                            <TableCell>
                              {nullHandler(valuation?.user?.work_title)?.toString()?.toPersianDigits()}
                            </TableCell>
                            <TableCell>
                              {nullHandler(valuation?.user?.first_name + " " + valuation?.user?.last_name)
                                ?.toString()
                                ?.toPersianDigits()}
                            </TableCell>
                          </>
                        )}
                        <TableCell>
                          {nullHandler((valuation?.first_name ?? "") + " " + (valuation?.last_name ?? ""))
                            ?.toString()
                            ?.toPersianDigits()}
                        </TableCell>
                        <TableCell>{nullHandler(valuation?.phone_number)?.toString()?.toPersianDigits()}</TableCell>
                        <TableCell>
                          {nullHandler(jMoment(new Date(valuation?.date)).format("jYYYY/jMM/jDD"))
                            ?.toString()
                            ?.toPersianDigits()}
                        </TableCell>
                        <TableCell>{nullHandler(valuation?.address)?.toString()?.toPersianDigits()}</TableCell>
                        <TableCell>{nullHandler(valuation?.id)?.toString()?.toPersianDigits()}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          </Grid>
        </Paper>
      </Grid>
      <Grid container alignItems='center' justifyContent='center' style={{ marginBottom: 10, marginTop: 30 }}>
        <Select
          labelId='demo-select-small'
          id='demo-select-small'
          value={perPage}
          // label='ردیف در صفحه'
          margin='dense'
          variant='outlined'
          onChange={(event) => setPerPage(event.target.value)}
        >
          {[10, 20, 50, 100, 200].map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>

        <Pagination count={count} onChange={handleChangePage} page={page} />
        <Button variant='outlined' onClick={handleGoToPageDialogOpen}>
          برو به صفحه
        </Button>
      </Grid>
      <Dialog open={goToPageDialogOpen} onClose={handleGoToPageDialogClose} maxWidth='xs' fullWidth>
        <DialogTitle>برو به صفحه</DialogTitle>
        <DialogContent>
          <TextField
            type={"number"}
            label='شماره صفحه'
            size='small'
            margin='dense'
            variant='outlined'
            fullWidth
            inputRef={pageNumRef}
            defaultValue={page}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleGoToPageDialogClose}>بستن</Button>
          <Button
            onClick={() => {
              if (pageNumRef?.current?.value) setPage(parseInt(pageNumRef?.current?.value));
              handleGoToPageDialogClose();
            }}
            variant='contained'
            color='primary'
          >
            برو
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default ValuationList;
